module.exports = {"finTube":{"finSemi":"Semi","finSurface":"Surface","finMaterialSpec":"Material Spec","finPattern":"Pattern","finLength":"Fin Length (Inch)","finHeight":"Fin Height (Inch)","finTubeHeight":"Tube High","finFPI":"FPI","finEdges":"Edges","tubeDiameter":"Tube Diameter","tubeInsideShape":"Inside Shape","tubeThinkness":"Thinkness (mm)","tubeFin":"Fin (Inch)","tubeType":"Type","tubeSemi":"Semi","tubeMaterialSpec":"Material Spec","mm":"(mm)","row":"Row","tubeFinLength":"FL (Inch)","tubeHairPin":"Hairpin (mm)","pattern":"Tube Pattern","finQuality":"Fin Quantity"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/fin.json
// module id = 934
// module chunks = 108